import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useContent } from "@/context/ContentContext";

export default function Footer() {
  const { content } = useContent();
  const brand = content?.brand || {};
  const footer = content?.footer || {};
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-surface">
      <div className="mx-auto max-w-[1400px] px-6 py-20 lg:px-12">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-6 max-w-sm text-lg font-light leading-relaxed text-slate-400">
              {footer.blurb}
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <p className="font-mono text-sm uppercase tracking-[0.2em] text-brand-blue">Navigate</p>
            <ul className="mt-6 space-y-3">
              {[
                ["About", "/about"],
                ["Courses", "/courses"],
                ["Pricing", "/pricing"],
                ["Journal", "/blog"],
                ["Contact", "/contact"],
              ].map(([l, to]) => (
                <li key={to}>
                  <Link to={to} className="link-underline text-slate-300 hover:text-white">
                    {l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-sm uppercase tracking-[0.2em] text-brand-blue">Get in touch</p>
            <ul className="mt-6 space-y-3 text-slate-300">
              <li>{brand.email}</li>
              <li>{brand.location}</li>
              <li>
                <Link to="/contact" className="text-brand-magenta hover:underline">
                  Book a consultation →
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 font-mono text-sm uppercase tracking-[0.15em] text-slate-400 sm:flex-row">
          <span>© {new Date().getFullYear()} {brand.companyName}</span>
          <span>{footer.tagline}</span>
        </div>
      </div>
    </footer>
  );
}
